module.exports = __webpack_public_path__ + "files/b883f281e9c4fad4b3ed885fa6d22cd3.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-italic-webfont.ttf
 ** module id = 993
 ** module chunks = 0
 **/